import { HereMapNew } from '@user/components/HereMap/HereMapNew/HereMapNew'
import * as React from 'react'
import { useApi } from '@user/features/MapView/MapViewDialog/ExploratoryMapNew/hooks/useApi'
import { MapViewDialogContentProps } from '@user/features/MapView/MapViewDialog/MapViewDialogContent'

export const ExploratoryMapNew = (props: MapViewDialogContentProps) => {
  const { refreshMapPins, isRendering } = useApi({
    foundLocationFromSearch: false,
  })

  return (
    <HereMapNew
      {...props}
      refreshMapPins={refreshMapPins}
      isMapRendering={isRendering}
    />
  )
}
